import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataCheck"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 20.385L15.3075 18.4425L14.25 19.5L17.25 22.5L22.5 17.25L21.4425 16.1925L17.25 20.385ZM8.75 6.5C9.16421 6.5 9.5 6.16421 9.5 5.75C9.5 5.33579 9.16421 5 8.75 5C8.33579 5 8 5.33579 8 5.75C8 6.16421 8.33579 6.5 8.75 6.5ZM8.75 12.5C9.16421 12.5 9.5 12.1642 9.5 11.75C9.5 11.3358 9.16421 11 8.75 11C8.33579 11 8 11.3358 8 11.75C8 12.1642 8.33579 12.5 8.75 12.5ZM8.75 18.5C9.16421 18.5 9.5 18.1642 9.5 17.75C9.5 17.3358 9.16421 17 8.75 17C8.33579 17 8 17.3358 8 17.75C8 18.1642 8.33579 18.5 8.75 18.5ZM18 2.25H6C5.17157 2.25 4.5 2.92157 4.5 3.75V20.25C4.5 21.0784 5.17157 21.75 6 21.75H12V20.25H6V15.75H19.5V3.75C19.5 2.92157 18.8284 2.25 18 2.25ZM18 14.25H6V9.75H18V14.25ZM6 8.25H18V3.75H6V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataCheck.vue"]]);
